import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b64662c")

_pushScopeId("data-v-5b64662c")
const _hoisted_1 = { class: "d-f df-middle edit__item" }
const _hoisted_2 = { class: "flex-1 content df-middle" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = {
  class: "name",
  style: {"font-weight":"400"}
}
const _hoisted_5 = { class: "f-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "d-ib wedge",
  style: {"width":"60px"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", _hoisted_4, _toDisplayString(_ctx.item.code), 1),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.item.tips), 1)
      ]),
      _createVNode("div", null, [
        _createVNode(_component_Icon, {
          name: "top",
          sm: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toTop', _ctx.item.code, _ctx.$el)))
        }),
        _hoisted_6,
        _createVNode(_component_Icon, {
          name: "menu",
          sm: ""
        })
      ])
    ])
  ]))
})